<template>
  <Header header__white="header__white" />
  <Breadcrumb title="Questionário" subtitle="Questionário" />
  <CheckoutArea />
  <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Inicio/Header.vue';
import Breadcrumb from '../components/Inicio/Breadcrumb.vue';
import CheckoutArea from '../components/Inicio/Questionario.vue';
import Footer from '../components/Inicio/Footer.vue';

export default {
  name: 'questionarioPage',
  components: {
    Header,
    Breadcrumb,
    CheckoutArea,
    Footer,
  }
}
</script>
